
import * as XLSX from 'xlsx';
import { Investor, Contact } from '@/types/investor';

export interface ExcelExportData {
  investors: Investor[];
  contacts?: Contact[];
}

export const exportToExcel = (data: ExcelExportData, filename: string = 'investors_data') => {
  // Create a new workbook
  const workbook = XLSX.utils.book_new();
  
  // Prepare investors data for export
  const investorsData = data.investors.map(investor => ({
    'ID': investor.id,
    'Name': investor.name || '',
    'Firm': investor.firm || '',
    'Relevance Score': investor.relevanceScore || 0,
    'Investment Focus': investor.investmentFocus || '',
    'Website': investor.website || '',
    'Keywords': Array.isArray(investor.keywords) ? investor.keywords.join(', ') : '',
    'Portfolio Companies': Array.isArray(investor.portfolioCompanies) ? investor.portfolioCompanies.join(', ') : '',
    'Enriched With': investor.enrichedWith || '',
    'Last Relevance Update': investor.lastRelevanceUpdate || '',
    'Confidence': investor.confidence || '',
    'Notes': investor.notes || '',
    'Contact Count': investor.contactCount || 0,
    'Location City': investor.location?.city || '',
    'Location State': investor.location?.state || '',
    'Enrichment Failed': investor.enrichmentFailed ? 'Yes' : 'No'
  }));
  
  // Create investors worksheet
  const investorsWS = XLSX.utils.json_to_sheet(investorsData);
  XLSX.utils.book_append_sheet(workbook, investorsWS, 'Investors');
  
  // If contacts are provided, create contacts worksheet
  if (data.contacts && data.contacts.length > 0) {
    const contactsData = data.contacts.map(contact => ({
      'ID': contact.id,
      'Name': contact.name || '',
      'Firm Name': contact.firmName || '',
      'Role': contact.role || '',
      'Email': contact.email || '',
      'LinkedIn': contact.linkedin || '',
      'Twitter': contact.twitter || '',
      'Phone': contact.phone || '',
      'Location': contact.location || '',
      'First Name': contact.firstName || '',
      'Last Name': contact.lastName || '',
      'Board Seats': contact.boardSeats || 0,
      'Deal Roles': contact.dealRoles || 0,
      'University': contact.university || '',
      'Gender': contact.gender || '',
      'Notes': contact.notes || ''
    }));
    
    const contactsWS = XLSX.utils.json_to_sheet(contactsData);
    XLSX.utils.book_append_sheet(workbook, contactsWS, 'Contacts');
  }
  
  // Generate filename with timestamp
  const timestamp = new Date().toISOString().split('T')[0];
  const fullFilename = `${filename}_${timestamp}.xlsx`;
  
  // Write and download the file
  XLSX.writeFile(workbook, fullFilename);
};
